export const testimonials = [
  {
    id: "t1",
    name: "小雨",
    role: "社交媒体创作者",
    avatar: "https://readdy.ai/api/search-image?query=Cute%20young%20Asian%20woman%20portrait%20avatar%2C%20soft%20natural%20lighting%2C%20warm%20smile%2C%20minimalist%20cream%20background%2C%20high%20quality%20digital%20art%2C%20friendly%20approachable%20style&width=100&height=100&seq=avatar-01&orientation=squarish",
    content: "用了AI美女生成平台后，我的小红书头像和封面图质量提升了不止一个档次！生成的图片超级自然，朋友们都以为我找了专业摄影师。",
    rating: 5,
  },
  {
    id: "t2",
    name: "星辰大海",
    role: "游戏角色设计师",
    avatar: "https://readdy.ai/api/search-image?query=Cool%20stylish%20Asian%20man%20portrait%20avatar%2C%20modern%20minimalist%20style%2C%20soft%20lighting%2C%20neutral%20cream%20background%2C%20high%20quality%20digital%20art%2C%20creative%20professional%20look&width=100&height=100&seq=avatar-02&orientation=squarish",
    content: "作为游戏角色设计师，AI虚拟美女功能简直是神器！能快速生成大量角色概念图，大大提高了我的工作效率。风格多样，质量稳定。",
    rating: 5,
  },
  {
    id: "t3",
    name: "樱花酱",
    role: "自媒体博主",
    avatar: "https://readdy.ai/api/search-image?query=Pretty%20young%20Asian%20woman%20portrait%20avatar%2C%20gentle%20sweet%20smile%2C%20soft%20pastel%20lighting%2C%20minimalist%20cream%20background%2C%20high%20quality%20digital%20art%2C%20friendly%20warm%20style&width=100&height=100&seq=avatar-03&orientation=squarish",
    content: "最喜欢AI美女壁纸功能！每天换个新壁纸，心情都变好了。生成的图片分辨率很高，放在手机上特别清晰，同事都问我在哪找的这么好看的壁纸。",
    rating: 5,
  },
  {
    id: "t4",
    name: "David王",
    role: "平面设计师",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Asian%20man%20portrait%20avatar%2C%20modern%20clean%20style%2C%20soft%20lighting%2C%20neutral%20cream%20background%2C%20high%20quality%20digital%20art%2C%20confident%20professional%20look&width=100&height=100&seq=avatar-04&orientation=squarish",
    content: "操作简单，效果惊艳！不需要任何设计基础就能生成高质量的美女图片。提示词功能很灵活，可以精确控制生成的风格和细节。强烈推荐！",
    rating: 4,
  },
  {
    id: "t5",
    name: "梦幻小鹿",
    role: "摄影爱好者",
    avatar: "https://readdy.ai/api/search-image?query=Elegant%20young%20Asian%20woman%20portrait%20avatar%2C%20artistic%20style%2C%20soft%20warm%20lighting%2C%20minimalist%20cream%20background%2C%20high%20quality%20digital%20art%2C%20graceful%20expression&width=100&height=100&seq=avatar-05&orientation=squarish",
    content: "作为一个摄影爱好者，我对图片质量很挑剔。但AI美女平台生成的图片真的让我服气！光影处理非常自然，构图也很专业，完全不输真人摄影。",
    rating: 5,
  },
  {
    id: "t6",
    name: "极客小明",
    role: "科技博主",
    avatar: "https://readdy.ai/api/search-image?query=Young%20tech-savvy%20Asian%20man%20portrait%20avatar%2C%20modern%20casual%20style%2C%20soft%20lighting%2C%20neutral%20cream%20background%2C%20high%20quality%20digital%20art%2C%20friendly%20smart%20look&width=100&height=100&seq=avatar-06&orientation=squarish",
    content: "体验过多款AI图像生成工具，这个平台的AI美女生成效果是最自然的。没有那种'AI感'，图片看起来就像是真人拍摄的。技术和审美都非常在线。",
    rating: 5,
  },
];